module.exports = __webpack_public_path__ + "static/img/application2-3.aa1e083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-3.jpg
// module id = Ko/r
// module chunks = 0